export default __webpack_public_path__ + "static/media/IFW_SoftwarePAGE1ONLY-04.04e29046.png";